require("./apis/react");
require("./dropdown");
require("./event-listener");
require("./inputs/email");
require("./inputs/multiple");
require("./inputs/single");
require("./locale");
require("./plugins/ajax");
require("./plugins/async");
require("./plugins/diacritics");
require("./plugins/keyboard");
require("./plugins/options-validator");
require("./plugins/react/templates");
require("./plugins/submenu");
require("./plugins/tokenizer");
require("./selectivity");
require("./templates");
module.exports=require("./selectivity");
